<template>
  <div>
    <div class="header send-sms-activity-summary-text">Send SMS Activity Summary</div>
    <el-row>
      <el-col :span="12">
        <div class="column-header data-label short-long-code-text">Short/Long Code</div>
        <div class="column-content subscriber-opt-in-code">
          <span class="message-code-locale">HKBN</span>
          <span class="message-code">+852 622649290904</span>
        </div>
      </el-col>
      <el-col :span="12">
        <div class="column-header data-label message-text">SMS Content</div>
        <div class="column-content subscriber-opt-in-message"><span v-for="(item, index) in this.msgPreviewParsed"
            :key='index' :style="{ backgroundColor: item.isHighlight ? 'yellow' : 'transparent' }">{{ item.content }}</span>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="12">
        <div class="column-header data-label sms-channel-text">SMS Channel</div>
        <div class="column-content sms-channel-message">{{ previewChannel.name + ' / ' + previewChannel.value }}</div>
      </el-col>
      <el-col :span="12">
        <div class="column-header data-label target-date-text">Target send date</div>
        <div class="column-content target-date-message">{{ targetDate }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <div class="column-header data-label target-date-text">Shorten URL Option</div>
        <div class="column-content target-date-message">{{ isEnableShorten ? 'Enable' : 'Disable' }}</div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div class="column">
          <div class="column-header data-label send-blackout-window-text">Send blackout window</div>
          <div class="column-content blackout-summary">
            <div class="blackout-option" v-if="blackoutType === '0'">Do not use send blackout window</div>
            <div class="blackout-option" v-if="blackoutType === '1'">Use existing MobileConnect blackout window</div>
            <div class="blackout-option" v-if="blackoutType === '2'">Use custom settings for this message</div>

            <div class="blackout-window" v-if="blackoutType === '2'">{{ startTime + ' - ' + endTime }}</div>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div class="column">
          <div class="column-header data-label send-blackout-window-text">Teams Alert Notification</div>
          <div>{{ notification }}</div>
        </div>
      </el-col>
    </el-row>
    <el-row>
      <div style="color: red; margin-top: 20px">
        Please make sure that MOBILE is selected as "Default Mobile Number" in Journey Setting.
      </div>
    </el-row>
  </div>
</template>

<script>
import { ShortenUrlDelimiterRegexp, ShortenUrlLookupRegexp } from "../utils/RegexpHelper"
export default {
  name: 'Summary',
  props: ['message', 'previewChannel', 'targetDate', 'blackoutType', 'isEnableShorten', 'notification'],
  computed: {
    msgPreviewParsed() {
      return this.message.split(ShortenUrlDelimiterRegexp).map(text => {
        return { content: text, isHighlight: ShortenUrlLookupRegexp.test(text) }
      })
    }
  }
}
</script>